import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  fetchTranslatorLanguagesSuccess,
  fetchTranslatorLanguagesFailure,
  fetchTranslatedTextSuccess,
  fetchTranslatedTextFailure,
  detectLanguageSuccess,
  detectLanguageFailure,
} from './translation-modal-actions';

export function* doFetchSupportedLanguages(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `translations/azure/languages?userLanguage=${action.payload.userLanguage}`,
      options: {
        method: 'GET',
        errorMessage: 'Could not fetch supportedLanguages',
        retryAction: action,
      },
    });
    yield put(fetchTranslatorLanguagesSuccess(results));
  } catch (err) {
    yield put(fetchTranslatorLanguagesFailure(err));
  }
}

export function* doFetchTranslatedText(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `translations/azure/translate?to=${action.payload.to}&from=${action.payload.from}`,
      options: {
        method: 'POST',
        body: JSON.stringify({
          text: action.payload.text,
        }),
        errorMessage: 'Could not fetch translated text',
        retryAction: action,
      },
    });
    yield put(fetchTranslatedTextSuccess(results));
  } catch (err) {
    yield put(fetchTranslatedTextFailure(err));
  }
}

export function* doDetectLanguage(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'translations/azure/detect',
      options: {
        method: 'POST',
        body: JSON.stringify({
          text: action.payload.text,
        }),
        errorMessage: 'Could not detect language',
        retryAction: action,
      },
    });
    yield put(detectLanguageSuccess(results));
  } catch (err) {
    yield put(detectLanguageFailure(err));
  }
}

function* watchFetchSupportedLanguages() {
  yield takeLatest(actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES, doFetchSupportedLanguages);
}
function* watchTranslatedText() {
  yield takeLatest(actionTypes.FETCH_TRANSLATED_TEXT, doFetchTranslatedText);
}
function* watchDetectLanguage() {
  yield takeLatest(actionTypes.DETECT_LANGUAGE, doDetectLanguage);
}

export default [
  fork(watchFetchSupportedLanguages),
  fork(watchTranslatedText),
  fork(watchDetectLanguage),
];
